"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16"
}, _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M10.87 5.35V4.4a3.4 3.4 0 10-6.78 0v.96a3.4 3.4 0 006.78 0zM7.48 0a4.4 4.4 0 00-4.4 4.4v.95c0 1.08.4 2.07 1.04 2.83a89.86 89.86 0 00-2.25.95c-.37.17-.71.34-.9.47-.46.29-.7.77-.82 1.33a8.84 8.84 0 00-.14 2.1A1 1 0 001 14H10.49a4.92 4.92 0 01.08-1H1c-.02-.81.01-1.42.11-1.85.1-.43.25-.62.39-.71.12-.08.4-.22.78-.4a44.38 44.38 0 012.65-1.1 4.37 4.37 0 005.05.02 92.12 92.12 0 012.4 1 5 5 0 011.03-.63l-.42-.2a45.32 45.32 0 00-2.18-.92 4.37 4.37 0 001.05-2.86V4.4A4.4 4.4 0 007.48 0zM14 11.63c0-.28.22-.5.5-.5h3c.27 0 .5.22.5.5v3a.5.5 0 11-1 0v-1.8l-3.27 3.04a.5.5 0 01-.68-.74l3.24-3h-1.8a.5.5 0 01-.5-.5z"
}));

exports.default = _default;